import { useEffectOnce } from 'usehooks-ts';
import './XSDisableScroll.css';

let countOverlays = 0;

export function XSDisableScroll() {
    const className = 'xs-disable-scroll';

    useEffectOnce(() => {
        const scrollPosition = window.scrollY;
        const element = document.getElementById('root');
        countOverlays += 1;
        const isRoot = countOverlays === 1;

        if (isRoot && element) {
            element.classList.add(className);
            element.style.top = `-${scrollPosition}px`;
        }

        return () => {
            countOverlays -= 1;

            if (isRoot && element) {
                element.classList.remove(className);
                element.style.top = '';
                window.scrollTo(0, scrollPosition); // Restore the scroll position
            }
        };
    });

    return null;
}
